import {Box} from "@mui/material";

export const blackColor = "black";
export const paperColor = "white";
export const mainColor = "#d62a8e";
export const secondColor = "#3222a5";
export const thirdColor = "#E6F4FF";
export const disabledColor = "#8a8b8e";

export const mainWhite = "white";
export const titleTextColor = "#2509e9";
export const mainTextColor = "#000000";
export const secondTextColor = "#3222a5";
export const BubbleColor = "#3222a5";
export const thirdTextColor = "white";

export const backgroundColor = "#EFEFEF";


export const font = '"Montserrat", "DejaVu Sans", "Arial", sans-serif';

export const fontWidthThin = 200;
export const fontWidthMedium = 300;
export const fontWidthStrong = 400;
export const fontWidthVeryStrong = 700;
export const fontSizeVeryStrong = "1.8rem";
export const fontLineHeightVeryStrong = "2.2rem";

export const defaultMargin = "25px";

export const typeOfLcf = {
    "1": "Ensemble compact de tours",
    "2": "Ensemble compact d'immeubles",
    "3": "Ensemble compact de maison",
    "4": "Ensemble de tours espacées",
    "5": "Ensemble d'immeubles espacés",
    "6": "Ensemble de maisons espacées",
    "8": "Batiments bas de grande emprise",
    "9": "Implantation diffuse de maison",
    "A": "Espace densément arboré",
    "B": "Espace arboré clairsemé",
    "C": "Espace végétalisé hétérogène",
    "D": "Végétation basse",
    "E": "Sol Imperméable naturel ou artificiel",
    "F": "Sol nu imperméable",
    "G": "surface en eau",
}


export const legends = {
    "1": "Très forte sensibilité à l'ilot de Chaleurs Urbains",
    "2": "Très forte sensibilité à l'ilot de Chaleurs Urbains",
    "3": "Forte sensibilité à l'ilot de Chaleurs Urbains",
    "4": "Sensibilité moyenne à l'ilot de Chaleurs Urbains",
    "5": "Sensibilité moyenne à l'ilot de Chaleurs Urbains",
    "6": "Faible sensibilité à l'ilot de Chaleurs Urbains",
    "8": "Faible sensibilité à l'ilot de Chaleurs Urbains",
    "9": "Faible sensibilité à l'ilot de Chaleurs Urbains",
    "A": "Non baties sensibilité faible à nulle",
    "B": "Non baties sensibilité faible à nulle",
    "C": "Non baties sensibilité faible à nulle",
    "D": "Non baties sensibilité faible à nulle",
    "E": "Non baties sensibilité faible à nulle",
    "F": "Non baties sensibilité faible à nulle",
    "G": "Non baties sensibilité faible à nulle",
}

export const newColorScale = {
    "urb": "#c0c0c0",
    "veg": "#00ff00",
    "1": '#921410',
    "2": '#d41c16',
    "3": '#ff1f19',
    "4": '#c25618',
    "5": '#fa6e1c',
    "6": '#fe9f5e',
    "7": '#de9900',
    "8": '#bfbfbf',
    "9": '#ffceaf',
    "A": '#197114',
    "B": '#26ad1e',
    "C": '#6c8b32',
    "D": '#bddd80',
    "E": '#0d0d0d',
    "F": '#fbf7b2',
    "G": '#7171ff',
}

export const colorScale = [
    [1, '#921410'],
    [2, '#d41c16'],
    [3, '#ff1f19'],
    [4, '#c25618'],
    [5, '#fa6e1c'],
    [6, '#fe9f5e'],
    [8, '#bfbfbf'],
    [9, '#ffceaf'],
    [11, '#197114'],
    [12, '#26ad1e'],
    [13, '#6c8b32'],
    [14, '#bddd80'],
    [15, '#0d0d0d'],
    [16, '#fbf7b2'],
    [17, '#7171ff'],
]

export const cardsHelp = {
    "Gestion de l'eau": "L'eau contribue au rafraîchissement urbain :<ul>" +
        "<li> Intégration de plans d'eau et fontaines dans l'aménagement urbain.</li>" +
        "<li> Utilisation de pavés évaporatifs et systèmes d'humidification des chaussées, pouvant réduire la température du sol de 10 à 15°C et celle de l'air de 5 à 8°C</li>" +
        "<li> Récupération et utilisation des eaux pluviales pour l'arrosage et les systèmes de rafraîchissement</li>" +
        "</ul>",
    "Aménagement urbain bioclimatique": "La conception des espaces urbains doit intégrer les enjeux climatiques :<ul>" +
        "<li> Optimisation de l'organisation spatiale pour favoriser la circulation de l'air.</li>" +
        "<li> Prise en compte de l'orientation des bâtiments et des rues pour limiter l'exposition solaire</li>" +
        "<li> Création d'ombrages dans les espaces publics\n</li>" +
        "</ul>",
    "Végétalisation": "La végétation joue un rôle crucial dans la régulation thermique urbaine :<ul>" +
        "<li> Plantation d'arbres : Les zones boisées urbaines sont 2 à 8°C plus fraîches que le reste de la ville.</li>" +
        "<li> Création de parcs et espaces verts</li>" +
        "<li> Végétalisation des bâtiments : Les murs et toitures végétalisés peuvent réduire significativement la température de surface</li>" +
        "</ul>",
    "Adaptation des matériaux et revêtements": "Le choix des matériaux impacte fortement la température urbaine :<ul>" +
        "<li> Utilisation de revêtements à albédo élevé (pouvoir de réflexion d’une surface exposée à la lumière), qui réfléchissent mieux le rayonnement solaire</li>" +
        "<li> Désimperméabilisation des sols pour favoriser l'évaporation naturelle.</li>" +
        "<li> Peinture des toits en blanc, une pratique simple et efficace</li>" +
        "</ul>",
    "Adaptation des comportements": "Les pratiques individuelles et collectives jouent également un rôle important :<ul>" +
        "<li> Promotion des mobilités douces pour réduire les émissions de chaleur anthropique</li>" +
        "<li> Limitation de l'usage de la climatisation, qui rejette de la chaleur à l'extérieur</li>" +
        "<li> Sensibilisation aux bonnes pratiques et adaptation des horaires de travail en période de canicule</li>" +
        "</ul>",
}

export function formatSurface(localSurfaceElement) {
    return new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 1}).format(
        (localSurfaceElement) * 0.0001,
    ) + " Hectares";
}

export function formatPerc(localSurfaceElement, surface) {
    return new Intl.NumberFormat('fr-FR', {style: 'percent', maximumFractionDigits: 1}).format(
        localSurfaceElement / surface,
    );
}

export function cleanNomQuartier(nomQuartier) {
    return nomQuartier.replace(" (commune non irisée)", "")

}

export function getHeaderSynthese(pageCommune, isAnArrondissement, nomArrondissement, nomCommune, nomQuartiers) {
    let listQuartiers = ""
    if (nomQuartiers) {
        nomQuartiers.map((quartier) => {
            listQuartiers += cleanNomQuartier(quartier) + ", "
        })
        listQuartiers = listQuartiers.substring(0, listQuartiers.length - 2)

    }
    if (pageCommune) {
        if (isAnArrondissement) {
            return "Vous trouverez ci-dessous pour " + nomArrondissement + " (" + listQuartiers + ") les typologies de zones climatiques locales les plus représentées en termes d’occupation de l’espace"
        } else {
            if (nomQuartiers.length > 1) {
                return "Vous trouverez ci-dessous pour les communes de " + listQuartiers + " les typologies de zones climatiques locales les plus représentées en termes d’occupation de l’espace"
            } else {

                return "Vous trouverez ci-dessous pour la commune de " + listQuartiers + " les typologies de zones climatiques locales les plus représentées en termes d’occupation de l’espace"
            }
        }
    }

    if (nomCommune.includes("commune non irisée")) {
        return "Vous trouverez ci-dessous pour la commune de " + cleanNomQuartier(nomCommune) + " les typologies de zones climatiques locales les plus représentées en termes d’occupation de l’espace"
    } else {

        return "Vous trouverez ci-dessous pour le quartier de " + nomCommune + " les typologies de zones climatiques locales les plus représentées en termes d’occupation de l’espace"
    }

}

export function getDescription() {
    return "Les <strong>Zones Climatiques Locales</strong> fournissent un pré-diagnostic climatique intégrant la morphologie urbaine et l'occupation des sols. <br />" +
        "<br />" +
        "Elles permettent de :<br />" +
        "- <strong>Localiser les zones à enjeux</strong> (quartiers ou îlots sensibles) où l'effet Ilots de Chaleurs Urbains est le plus marqué.<br />" +
        "- <strong>Prioriser les actions</strong> et affiner les analyses pour élaborer des stratégies adaptées aux spécificités de votre territoire.<br />" +
        "Cette analyse s’appuie sur les données satellite SPOT de 2022<br />" +
        "<br />" +
        "Un <strong>Ilot de Chaleur Urbain</strong> correspond à un <strong>écart positif de température</strong> entre le centre urbain et les zones périphériques rurales ou naturelles. <br />" +
        "Ce phénomène est influencé par :<br />" +
        "- <strong>La densité urbaine</strong> et la forme des villes.<br />" +
        "- <strong>L’artificialisation des sols</strong> et les matériaux de construction.<br />" +
        "- <strong>Les activités anthropiques</strong> (transport, industrie, etc.).<br />" +
        "- <strong>La présence ou l’absence de végétation et de plans d’eau.</strong><br />" +
        "<br />" +
        "Son intensité varie :<br />" +
        "- <strong>En été</strong>, il est particulièrement marqué lors de longues périodes sans précipitations et sous des conditions de faible vent et ensoleillement prolongé.<br />" +
        "- <strong>La nuit</strong>, l’effet est maximal : les surfaces urbaines dense restituent lentement la chaleur accumulée, entraînant des écarts pouvant atteindre <strong>jusqu’à 10 °C</strong> entre le centre et la périphérie lors des vagues de chaleur.<br />" +
        "<br />" +
        "<strong>Un enjeu majeur pour les territoires</strong><br />" +
        "<br />" +
        "Les Ilots de Chaleurs Urbains amplifient les impacts des canicules sur <br />" +
        "- <strong>La santé des populations</strong> (personnes âgées, enfants, personnes vulnérables).<br />" +
        "- <strong>Les infrastructures urbaines</strong> soumises à des stress thermiques accrus.<br />" +
        "- <strong>La biodiversité</strong>, particulièrement en milieu urbain.<br />" +
        "<br />" +
        "Dans un contexte d’urbanisation croissante et de changement climatique, l’Ilot de Chaleur Urbain constitue un risque important pour les territoires. <br />" +
        "Grâce aux données des zones Climatiques Locales, vous disposez d’une base essentielle pour agir efficacement face à ce défi.<br /><br />" +
        "<strong>Description des zones climatiques locales (Stewart et Oak)</strong><br />";
}

export function getNomArrondissement(codeInsee) {
    let code = codeInsee.toString().substring(0, 5)
    console.log(codeInsee)
    if (code in arrondissements) {
        return arrondissements[code];
    }
    return ""
}


export const arrondissements = {
    13001: "Marseille 1er Arrondissement",
    13002: "Marseille 2e Arrondissement",
    13003: "Marseille 3e Arrondissement",
    13004: "Marseille 4e Arrondissement",
    13005: "Marseille 5e Arrondissement",
    13006: "Marseille 6e Arrondissement",
    13007: "Marseille 7e Arrondissement",
    13008: "Marseille 8e Arrondissement",
    13009: "Marseille 9e Arrondissement",
    13010: "Marseille 10e Arrondissement",
    13011: "Marseille 11e Arrondissement",
    13012: "Marseille 12e Arrondissement",
    13013: "Marseille 13e Arrondissement",
    13214: "Marseille 14e Arrondissement",
    13215: "Marseille 15e Arrondissement",
    13216: "Marseille 16e Arrondissement",
    69001: "Lyon 1er Arrondissement",
    69002: "Lyon 2e Arrondissement",
    69003: "Lyon 3e Arrondissement",
    69004: "Lyon 4e Arrondissement",
    69005: "Lyon 5e Arrondissement",
    69006: "Lyon 6e Arrondissement",
    69007: "Lyon 7e Arrondissement",
    69008: "Lyon 8e Arrondissement",
    69009: "Lyon 9e Arrondissement",
    69381: "Lyon 1er Arrondissement",
    69382: "Lyon 2e Arrondissement",
    69383: "Lyon 3e Arrondissement",
    69384: "Lyon 4e Arrondissement",
    69385: "Lyon 5e Arrondissement",
    69386: "Lyon 6e Arrondissement",
    69387: "Lyon 7e Arrondissement",
    69388: "Lyon 8e Arrondissement",
    69389: "Lyon 9e Arrondissement",
    75101: "Paris 1er Arrondissement",
    75102: "Paris 2e Arrondissement",
    75103: "Paris 3e Arrondissement",
    75104: "Paris 4e Arrondissement",
    75105: "Paris 5e Arrondissement",
    75106: "Paris 6e Arrondissement",
    75107: "Paris 7e Arrondissement",
    75108: "Paris 8e Arrondissement",
    75109: "Paris 9e Arrondissement",
    75110: "Paris 10e Arrondissement",
    75111: "Paris 11e Arrondissement",
    75112: "Paris 12e Arrondissement",
    75113: "Paris 13e Arrondissement",
    75114: "Paris 14e Arrondissement",
    75115: "Paris 15e Arrondissement",
    75116: "Paris 16e Arrondissement",
    75117: "Paris 17e Arrondissement",
    75118: "Paris 18e Arrondissement",
    75119: "Paris 19e Arrondissement",
    75120: "Paris 20e Arrondissement",

}

export function noData() {
    return (
        <Box sx={{width: "95%", height: "80%", m: 5, display: "flex", flexDirection: "column"}}>
            <Box sx={{
                display: "flex",
            }}>
                La territoire sélectionné ne fait pas partie du référentiel cartographie des zones climatiques locales
                couvrant 83 aires urbaines de plus de 50 000 habitants en France
            </Box>
        </Box>)
}